// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List       = require("bs-platform/lib/js/list.js");
var $$Array    = require("bs-platform/lib/js/array.js");
var Js_dict    = require("bs-platform/lib/js/js_dict.js");
var Firebase   = require("../ffi/Firebase");
var Caml_array = require("bs-platform/lib/js/caml_array.js");

function convert(categories) {
  var keys = Object.keys(categories);
  var values = $$Array.to_list(Js_dict.values(categories));
  return List.mapi((function (i, c) {
                return {
                        id: Caml_array.caml_array_get(keys, i),
                        name: c
                      };
              }), values);
}

function getCategories(uid) {
  var path = "categories/" + uid;
  var ref = Firebase.db.ref(path);
  return ref.once("value").then((function (snapshot) {
                var c = snapshot.val();
                return Promise.resolve((c == null) ? /* [] */0 : convert(c));
              }));
}

exports.convert       = convert;
exports.getCategories = getCategories;
/* Js_dict Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/model/Category.re
// module id = 265
// module chunks = 0